<template>
  <g class="grid">
    <line
      :class="['grid-y-line', { baseline: tick === 0 }]"
      v-for="(tick, tickIndex) in p.ticksY"
      :key="'y-' + tickIndex"
      :x1="+p.left"
      :x2="p.width - p.right"
      :y1="p.scaleY(tick)"
      :y2="p.scaleY(tick)"
      :stroke-dasharray="c.gridYStrokeDash"
      :style="{
        stroke: c.gridYStrokeColor,
        strokeWidth:
          tick === 0 ? c.gridYBaselineStrokeWidth : c.gridYStrokeWidth,
      }"
    ></line>
    <template v-if="xLine">
      <line
        :class="'grid-x-line'"
        v-for="(tick, tickIndex) in p.ticksX"
        :key="'x-' + tickIndex"
        :x1="p.scaleX(tick)"
        :x2="p.scaleX(tick)"
        :y1="p.scaleY(p.minY)"
        :y2="p.scaleY(getValueLineHeigth(tick))"
        :stroke-dasharray="c.gridXStrokeDash"
        :style="{
          stroke:tickIndex == p.ticksX.length -1 ? c.gridXStrokeColor[1] : c.gridXStrokeColor[0],
          strokeWidth:tickIndex == p.ticksX.length -1 ? c.gridXStrokeWidth[1] : c.gridXStrokeWidth[0],
        }"
      ></line>
    </template>
  </g>
</template>

<script>
export default {
  props: {
    p: {
      name: "params",
      required: true,
    },
    c: {
      name: "config",
      required: true,
    },
    d: {
      name: "data",
      required: true,
    },
    xLine: {
      default: true,
    },
  },
  methods: {
    getValueLineHeigth(tick) {
      const xAxisDataKey = this.c.xAxis;
      return this.d.find((x) => x[xAxisDataKey] == tick)[this.serieKey];
    },
  },
  computed: {
    serieKey() {
      return this.c.series[0].key;
    },
  },
};
</script>

<style lang="scss" scoped>
.grid {
  overflow: hidden;
}
</style>
